import { cn } from "@d12labs/utils";
import type * as React from "react";

/**
 * Filter pill — the segmented toggle used in toolbars (All / Hot / Active / …).
 * Active = surface-2 lift with a stronger hairline; inactive = transparent.
 */
export function Pill({
	active = false,
	className,
	children,
	...props
}: React.ComponentProps<"button"> & { active?: boolean }) {
	return (
		<button
			type="button"
			data-slot="pill"
			className={cn(
				"h-7 rounded-md border px-2.5 text-body-sm font-medium transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring/50",
				active
					? "border-hairline-strong bg-surface-2 text-foreground"
					: "border-hairline bg-transparent text-ink-subtle hover:bg-surface-1 hover:text-foreground",
				className,
			)}
			{...props}
		>
			{children}
		</button>
	);
}
